import { fabric } from 'fabric';
import Swiper, { Navigation, Autoplay } from 'swiper';
import PopulateClass from './classes/populate.js';

import { loadingView, unloadingView } from '../../loader.js';
import '../../../css/modules/personnalisation/personnalisationfrontdesktop.scss';

// import { observeNumeric } from './common.js';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import 'swiper/scss/scrollbar';
import 'swiper/scss/autoplay';
// import 'swiper/scss/zoom';

export default class customizationFrontDesktop {
    async init() {
        console.log('init Desktop');
        const storage = {
            verticalOrientation: false,
        };
        const Populate = new PopulateClass(storage);
        Populate.setInterface('desktop');

        if ($('body').hasClass('personnalisation')) {
            const wrapperHeight = $(window).height();
            const header = $('#header').find('.container').outerHeight(true);
            const France = $('#france').outerHeight(true);
            const bordureAutre = 120;
            const containerHeight = France
                + $('#header').find('.container').outerHeight(true)
                + bordureAutre;
            if (wrapperHeight - containerHeight > $('#selection-list').height()) {
                $('#selection-list').css({
                    height: wrapperHeight - containerHeight,
                });
            }
        }

        if ($('#load-template').length) {
            Populate.storage.products = JSON.parse($('#load-template').attr('data-products'));
            const result = await Populate.class.Ajax.loadData();
            console.log('#load-template result', result);
            Populate.storage.productData = result.productData;

            $('.tab, .order-tab').on('click', function () {
                Populate.class.Dom.clickOnOrderTab($(this));
            });

            $('.confirm-element .cancel').on('click', function () {
                // e.preventDefault();
                const panel = $(this).closest('.panel').attr('id');
                console.log(`confirm-element .cancel -> panel = ${panel}`);

                switch (panel) {
                    case 'textbelt-panel':
                    case 'attributes-panel':
                    case 'othercustom-panel':
                        console.log(`hide ${panel}`);
                        $(`#${panel}`).hide();
                        Populate.class.Dom.openSwiper('picture');
                        break;
                }
                Populate.storage.canvas.renderAll();
                Populate.class.Dom.closePanel(panel, 'cancel');
            });

            $('#load-template').on('click', '.confirm-element .confirm', function () {
                console.log('confirm-element .confirm click', Populate.storage.stepJsonCanvas);
                Populate.class.Dom.clickConfirmElement($(this));
            });
            $('#input_txt_ceinture').on('cut copy paste', (e) => {
                e.preventDefault();
            });

            $('#bloc_custom').css('display', 'flex');

            // function setVH() {
            //     // Calculer 1vh en fonction de la hauteur réelle visible
            //     const vh = window.innerHeight * 0.01;
            //     document.documentElement.style.setProperty('--vh', `${vh}px`);
            // }

            // // Initialiser à l'ouverture de la page
            // setVH();

            // // Mettre à jour en cas de redimensionnement
            // window.addEventListener('resize', setVH);


            // TOOLTIPS BUT DESACTIVATED
            // $('[data-toggle="tooltip"]').tooltip();

            $('#input_txt_ceinture').on('keyup', (e) => {
                if (e.keyCode === 13) {
                    $('#textbelt-panel')
                        .find('.confirm-element .confirm')
                        .trigger('click');
                }
            });

            Populate.class.Canvas.initFilterBackend();

            if (Populate.storage.productData.interface.panels.picture.restrict.addRotation === true) {
                Populate.class.Dom.observeNumeric('picture-angle', Populate.storage.canvas);
            }

            if (Populate.storage.productData.interface.panels.picture.restrict.addZoom === true) {
                Populate.class.Dom.observeNumeric('picture-zoom', Populate.storage.canvas);
            }
            if (Populate.storage.productData.interface.panels.text.restrict.addZoom === true) {
                Populate.class.Dom.observeNumeric('text-zoom', Populate.storage.canvas);
            }
            if (Populate.storage.productData.interface.panels.text.restrict.addRotation === true) {
                Populate.class.Dom.observeNumeric('text-angle', Populate.storage.canvas);
            }
            if (Populate.storage.productData.interface.panels.text.restrict.maxlength) {
                $('#input_txt_ceinture').attr('maxlength', Populate.storage.productData.interface.panels.text.restrict.maxlength);
                $('#input_txt_ceinture').attr('placeholder', `Saisissez votre texte ici (${Populate.storage.productData.interface.panels.text.restrict.maxlength} caractères maximum)`);
            }

            if (Populate.storage.productData.interface.panels.sticker.restrict.addZoom === true) {
                Populate.class.Dom.observeNumeric('sticker-zoom', Populate.storage.canvas);
            }
            if (Populate.storage.productData.interface.panels.sticker.restrict.addRotation === true) {
                Populate.class.Dom.observeNumeric('sticker-angle', Populate.storage.canvas);
            }
            Populate.class.Dom.observeNumeric('angle', Populate.storage.canvas);
            Populate.class.Dom.observeNumeric('brightness', Populate.storage.canvas);

            $('#filtersSwiper').on('click', '#brownie', function (e) {
                console.log($(this).prop('checked'));
                if ($(this).prop('checked') === true) {
                    $(this).prop('checked', true);
                    console.log('apply filter');
                    applyFilter(4, $(this).prop('checked') && new Populate.storage.fabric.filter.Brownie());
                } else {
                    console.log('doit desactiver le filtre');
                }
            });

            $('h1').html(Populate.storage.productData.productInfo.name);

            if (Populate.storage.mobile === false && Populate.storage.productData.productInfo.desc) {
                $('#productName').after(Populate.storage.productData.productInfo.desc);
            }

            (function ($, win) {
                $.fn.inViewport = function (cb) {
                    return this.each((i, el) => {
                        function visPx() {
                            const elH = $(el).outerHeight();
                            const H = $(win).height();
                            const r = el.getBoundingClientRect();
                            const t = r.top;
                            const b = r.bottom;

                            return cb.call(el, Math.max(0, t > 0 ? Math.min(elH, H - t) : Math.min(b, H)));
                        }
                        visPx();
                        $(win).on('resize scroll', visPx);
                    });
                };
            }(jQuery, window));





            // RATING OF PRODUCT
            $('input[name="rating"]').on('change', (event, value, caption) => {
                loadingView('personnalisation', 'create.svg', "Notation de l'interface ...", null, () => {
                    $.ajax({
                        type: 'POST',
                        url: `${prestashop.urls.base_url}modules/personnalisation/action.php`,
                        dataType: 'json',
                        data: {
                            method: 'notation',
                            interface: 'bureau',
                            id_product: $('#load-template').attr('data-id_product'),
                            note: value,
                        },
                        success(json) {
                            $('#arrow').html('Merci !');
                            unloadingView('personnalisation');
                        },
                    });
                });
            });

            // STAY ON THE PAGE IF CLICKOUT
            $('body.personnalisation').on('click', '.btn_user_header, #logo-link, #search_and_menu, #btnmenu', function (e) {
                e.preventDefault();
                const result = confirm(
                    "ATTENTION : Votre produit n'est pas encore enregistré. Souhaitez-vous vraiment quitter l'outil de personnalisation et tout perdre ?",
                );

                if (result) {
                    window.location.href = $(this).attr('href');
                }
            });

            Populate.storage.swiper.picture = new Swiper('#swiper-container-picture', {
                direction: 'vertical',
                breakpoints: {
                    1024: {
                        slidesPerView: 6,
                    },
                    1280: {
                        slidesPerView: 7,
                    },
                },
            });
            Populate.storage.swiper.text = new Swiper('#swiper-container-text', {
                direction: 'vertical',
                spaceBetween: 0,
                breakpoints: {
                    1024: {
                        slidesPerView: 5,
                    },
                    1280: {
                        slidesPerView: 8,
                    },
                },
            });
            Populate.storage.swiper.sticker = new Swiper('#swiper-container-sticker', {
                direction: 'vertical',
                spaceBetween: 0,
                breakpoints: {
                    1024: {
                        slidesPerView: 5,
                    },
                    1280: {
                        slidesPerView: 8,
                    },
                },
            });
            Populate.storage.swiper.mask = new Swiper('#swiper-container-mask', {
                direction: 'vertical',
                spaceBetween: 0,
                breakpoints: {
                    1024: {
                        slidesPerView: 5,
                    },
                    1280: {
                        slidesPerView: 8,
                    },
                },
            });

            if ($('#wrapper_custom').length) {
                $('#alert-icon-size').on({
                    click(e) {
                        // console.log('click');
                        e.preventDefault();
                        $('#alert-icon-size').hide();
                        onObjectScaled(Populate.class.Canvas.getObject(Populate.storage.canvas, 'fabricObj_fond', 'picture'));
                    },
                });

                if (prestashop.ismobile === true && prestashop.istablet === true && verticalOrientation === true) {
                    console.log('reduction car verticval');
                    $('#load-template').css({
                        height:
                            $(window).height()
                            - $('#header').find('.container').height()
                            - $('#menu_custom').height(),
                    });
                } else {
                    $('#load-template').css({
                        height:
                            $(window).height() - $('#header').find('.container').height() - 110,
                    });
                }

                $('#bloc_custom .tab').removeClass('active');
                $('.panel').removeClass('active');
                $(this).addClass('active');

                const introCanvas = await Populate.class.Canvas.introCanvas();

                $(`label[for="imageLoader_${Populate.storage.canvas.step}"]`).css({
                    visibility: 'visible',
                });


                $(`#swiper-container-picture .bloc-column_${Populate.storage.canvas.step}`).css({
                    display: 'flex'
                });


                $(document).on('click', '.img_step', function (e) {
                    console.log('click on img_step');
                    e.preventDefault();
                    Populate.class.Dom.clickLoadStep($(this));
                });
            }

            $('.menu_custom').on('click', '.item-action', function (e) {
                console.log('### click .item-action');

                e.preventDefault();

                if ($(this).hasClass('offline') === true || $(this).closest('.right-block').parent('.swiper-slide').hasClass('offline') === true
                ) {
                    console.log('.item-action not active (offline)');
                    return true;
                }

                const end_point = $(this).data('action');
                console.log(`action : ${end_point}`);

                if ($(this).attr('data-anotherobject')) {
                    console.log('+++++data-anotherobject & type', $(this).attr('data-anotherobject'), $(this).attr('data-anotherobjecttype'));
                    var object = Populate.class.Canvas.getObject(Populate.storage.canvas, $(this).attr('data-anotherobject'), $(this).attr('data-anotherobjecttype'));
                } else if (end_point !== 'color-mask' && end_point !== 'open-textbelt-panel' && end_point !== 'color-belt-background') {
                    var object = Populate.class.Canvas.getObjectSystem(Populate.storage.canvas, Populate.storage.tabActive);
                    console.log(object);
                    /* if (object === false) {
                                                      const options = [];
                                                      options.message = `Sélectionnez avant un objet de type « ${Populate.class.Dom.getActiveTab('lang')} »`;
                                                      Populate.class.Dom.messageAlert(options);
                                                  } */
                } else {
                    console.log(object);
                }

                switch (end_point) {
                    case 'color-text':

                        Populate.class.Dom.clickOnPicker($('#color-picker-text'));
                        // });
                        // if (productData.interface.panels.text.restrict.unique === true) {
                        //     Populate.class.Canvas.setObject(
                        //         Populate.class.Canvas.getObject(
                        //             Populate.storage.canvas,
                        //             productData.interface.panels.text.restrict.objectName,
                        //         ),
                        //         {
                        //             fill: $(this).attr('data-color-code'),
                        //         },
                        //     );
                        // } else if (typeof Populate.storage.canvas.getActiveObject() !== 'undefined') {
                        //     Populate.class.Canvas.setObject(
                        //         Populate.class.Canvas.getObject(Populate.storage.canvas, Populate.storage.canvas.getActiveObject().get('name')),
                        //         {
                        //             fill: $(this).attr('data-color-code'),
                        //         },
                        //     );
                        // }
                        break;

                    case 'color-belt-background':
                        Populate.class.Canvas.setColorBelt($(this).attr('data-color-code'));
                        break;

                    case 'color-photo':
                        Populate.class.Canvas.addBackgroundColor(Populate.storage.canvas, $(this).attr('data-color-code'));
                        $('.order-tab').removeClass('offline');
                        break;

                    case 'color-mask':
                        Populate.class.Canvas.setOverlay($(this).attr('data-mask-code'), Populate.storage.canvas);
                        break;

                    case 'bold-text':
                        const boldType = object.fontWeight != 'bold' ? 'bold' : 'normal';
                        Populate.class.Canvas.setObject(object, {
                            fontWeight: boldType,
                        });
                        break;

                    case 'italic-text':
                        const italicType = object.fontStyle != 'italic' ? 'italic' : 'normal';
                        Populate.class.Canvas.setObject(object, {
                            fontStyle: italicType,
                        });
                        break;

                    case 'font-text':
                        Populate.class.Dom.loadAndUse($(this).data('font'), object, Populate.storage.canvas);
                        break;

                    case 'strokewidthless-text':
                        if (object.strokeWidth > 0) {
                            Populate.class.Canvas.setObject(object, {
                                strokeWidth: object.strokeWidth - 1,
                            });
                        }
                        break;

                    case 'strokewidthmore-text':
                        Populate.class.Canvas.setObject(object, {
                            strokeWidth: object.strokeWidth + 1,
                        });
                        break;

                    case 'strokecolor-text':
                        Populate.class.Canvas.setObject(object, {
                            stroke: '#ffffff',
                        });
                        break;

                    case 'smiley-text':
                        Populate.class.Canvas.addSticker(Populate.storage.canvas, {
                            imgSrc:
                                `/modules/personnalisation/views/img/${$(this).data('sticker')}`,
                            objectType: $(this).data('objecttype'),
                            areaRestrict: true,
                        });
                        Populate.class.Dom.activeItemsAction('text');
                        break;

                    case 'bubble-sticker':
                    case 'smiley-sticker':
                        Populate.class.Canvas.addSticker(Populate.storage.canvas, {
                            imgSrc:
                                `/modules/personnalisation/views/img/${$(this).data('sticker')}`,
                            objectType: $(this).data('objecttype'),
                            areaRestrict: true,
                        });
                        Populate.class.Dom.activeItemsAction('sticker');
                        break;

                    case 'sticker-delete':
                        Populate.class.Canvas.deleteObject(Populate.storage.canvas);
                        break;

                    case 'filter-delete':
                        Populate.class.Canvas.deleteAllFilters(object, Populate.storage.canvas);
                        break;
                    case 'font-delete':
                        Populate.class.Dom.loadAndUse('Lobster', object, Populate.storage.canvas);
                        break;
                    case 'beltbackground-delete':
                        Populate.class.Canvas.deleteBeltbackgroundColor(Populate.storage.canvas);
                        break;

                    case 'background-delete':
                        Populate.class.Canvas.initBackgroundColor(Populate.storage.canvas);
                        break;

                    case 'mask-delete':
                        initOverlay(Populate.storage.canvas);
                        break;

                    case 'open-picture-panel':
                        Populate.class.Dom.openPanel('picture-panel');
                        // swiperPhoto.update();
                        break;

                    case 'delete-photo':
                        console.log('Populate.storage.canvas', Populate.storage.canvas.step);
                        Populate.class.Canvas.deletePicture(Populate.storage.canvas.step);
                        break;

                    case 'move-left':
                        Populate.class.Canvas.setObject(object, {
                            left: object.left - 10,
                        });
                        break;

                    case 'move-up':
                        Populate.class.Canvas.setObject(object, {
                            top: object.top - 10,
                        });
                        break;
                    case 'move-right':
                        Populate.class.Canvas.setObject(object, {
                            left: object.left + 10,
                        });
                        break;
                    case 'move-down':
                        Populate.class.Canvas.setObject(object, {
                            top: object.top + 10,
                        });
                        break;

                    case 'flip-x':
                        var flip = true;

                        if (object.flipX == true) {
                            flip = false;
                        }
                        Populate.class.Canvas.setObject(object, {
                            flipX: flip,
                        });
                        break;

                    case 'flip-y':
                        var flip = true;

                        if (object.flipY == true) {
                            flip = false;
                        }
                        Populate.class.Canvas.setObject(object, {
                            flipY: flip,
                        });
                        break;

                    case 'front':
                        Populate.class.Canvas.modifyLayerObject(object, 'front');
                        break;

                    case 'back':
                        Populate.class.Canvas.modifyLayerObject(object, 'back');
                        break;

                    case 'filter-grayscale':
                        Populate.class.Canvas.applyFilter(0, new Populate.storage.fabric.filter.Grayscale());
                        break;

                    case 'filter-blackwhite':
                        Populate.class.Canvas.applyFilter(19, new Populate.storage.fabric.filter.BlackWhite());
                        break;
                    case 'filter-invert':
                        Populate.class.Canvas.applyFilter(1, new Populate.storage.fabric.filter.Invert());
                        break;

                    case 'filter-sepia':
                        Populate.class.Canvas.applyFilter(3, new Populate.storage.fabric.filter.Sepia());
                        break;

                    case 'filter-brownie':
                        Populate.class.Canvas.applyFilter(4, new Populate.storage.fabric.filter.Brownie());
                        break;

                    case 'filter-vintage':
                        Populate.class.Canvas.applyFilter(9, new Populate.storage.fabric.filter.Vintage());
                        break;

                    case 'filter-kodachrome':
                        Populate.class.Canvas.applyFilter(18, new Populate.storage.fabric.filter.Kodachrome());
                        break;

                    case 'filter-technicolor':
                        Populate.class.Canvas.applyFilter(14, new Populate.storage.fabric.filter.Technicolor());
                        break;

                    case 'filter-polaroid':
                        Populate.class.Canvas.applyFilter(15, new Populate.storage.fabric.filter.Polaroid());
                        break;

                    case 'open-textbelt-panel':
                        if (Populate.storage.current_step > 1 && Populate.storage.productData.interface.belt) {
                            const options = [];
                            options.message = 'Vous ne pouvez pas effecter un texte à cet endroit »';
                            Populate.class.Dom.messageAlert(options);
                            return false;
                        }
                        Populate.class.Dom.openPanel('textbelt-panel');
                        break;

                    case 'delete-text':
                        Populate.class.Dom.deleteText();
                        break;

                    case 'open-text-color-panel':
                        console.log('text color panel item action');
                        Populate.class.Dom.openPanel('text-color-panel');
                        $('#text-color-panel').attr('data-origin-color-code', object.fill);
                        break;

                    case 'open-text-style-panel':
                        Populate.class.Dom.openPanel('text-style-panel');
                        $('#text-style-panel').attr('data-origin-fontweight', Populate.class.Canvas.getObject(Populate.storage.canvas, 'fabricObj_text', 'text').fontWeight);
                        $('#text-style-panel').attr('data-origin-fontstyle', Populate.class.Canvas.getObject(Populate.storage.canvas, 'fabricObj_text', 'text').fontStyle);
                        break;

                    default:
                        console.log(`Sorry, we are out of ${end_point}.`);
                        Populate.class.Canvas.setStepJsonCanvas();
                }
                // Populate.class.Dom.commandBtnUpdate(Populate.storage.canvas);
                Populate.storage.canvas.renderAll();
            });

            /* FIN GESTION FICHIER UPLOAD */

            const dialogbox = function (message, title, buttonTxt, callback) {
                if (title === undefined) {
                    title = 'Oupss..';
                }

                if (buttonTxt === undefined) {
                    var buttonTxt = 'Fermer';
                }

                $('#dialogBox')
                    .html(message)
                    .dialog({
                        modal: true,
                        width: 300,
                        title,
                        close() {
                            if (typeof callback === 'function') {
                                console.log('callback');
                                callback();
                            }
                        },
                        buttons: [
                            {
                                text: buttonTxt,
                                click() {
                                    $(this).dialog('close');
                                },
                            },
                        ],
                    });
                errorMessage = '';
                return true;
            };

            $('#swiper-container-example').on('click', '.clipart-element', function (e) {
                e.preventDefault();

                $('.clipart-element').removeClass('clipart-element-selected');
                $(this).addClass('clipart-element-selected');

                if (Populate.storage.productData.interface.panels.example.restrict.removeAllObjects == true) {
                    // DELETE ALL CANVAS
                    console.log('DELETE ALL CANVAS removeAllObjects');
                    Populate.storage.canvas.getObjects().forEach((o) => {
                        Populate.class.Canvas.removeObject(Populate.storage.canvas, o.name);
                    });
                }

                const imgSrcOriginal = $(this).attr('src');

                if (imgSrcOriginal !== undefined) {
                    const imgSrc = imgSrcOriginal.replace('mini/mini-', '');
                    const libraryName = imgSrcOriginal.replace('/modules/personnalisation/views/img/library/mini/mini-', '');
                    let fileNameImg = libraryName.split('.');
                    fileNameImg = fileNameImg[0];

                    Populate.class.Canvas.setBackgroundImgToCanvas(Populate.storage.canvas, {
                        imgSrc,
                        library: 1,
                        libraryName,
                    });
                    // console.log('fontRandom before', Populate.class.Canvas.testTexteCeintureOriginal(), Populate.class.Canvas.testTexteCeintureSlogan(fileNameImg))
                    const originalText = Populate.class.Canvas.testTexteCeintureOriginal();
                    const sloganText = Populate.class.Canvas.testTexteCeintureSlogan(fileNameImg);
                    console.log('originalText & sloganText & current_step', originalText, sloganText, Populate.storage);
                    if (Populate.storage.canvas.step == 1 && Populate.storage.productData.interface.panels.text.restrict.objectName === 'fabricObj_text') {
                        if ((Populate.storage.productData.interface.slogan === true && Populate.class.Canvas.getObject(Populate.storage.canvas, 'fabricObj_text', 'text') === false) || Populate.class.Canvas.testTexteCeintureOriginal() === true || Populate.class.Canvas.testTexteCeintureSlogan(fileNameImg) === true) {
                            if (Populate.storage.productData.productInfo.name.includes('Boxer') === true && parseInt(Populate.storage.canvas.step) > 1) {
                                // NO TEXT ON BACK SIDE BOXER
                            } else {
                                Populate.class.Canvas.setTextInputOnCanvas(Populate.class.Canvas.getTexteCeintureSlogan(fileNameImg), Populate.storage.canvas);
                                const object = Populate.class.Canvas.getObject(Populate.storage.canvas, 'fabricObj_text', 'text');
                                const fontRandom = Populate.class.Dom.randomFont();
                                Populate.class.Dom.loadAndUse(Populate.storage.fontsList[fontRandom], object, Populate.storage.canvas);
                            }
                        }
                    }
                    if (Populate.storage.productData.interface.panels.picture.restrict.unique === true) {
                        $('#photo-upload-txt').html('Modifier');
                    }
                    Populate.class.Dom.closePanel('example', 'confirm');
                }
            });
        }
    }

    getFilter(index) {
        const obj = Populate.storage.canvas.getActiveObject();

        return obj.filters[index];
    }

    showBtns(obj) {
        // console.log(obj);
        // onsole.log(obj.oCoords.tr.x);
        // console.log(obj.oCoords.tr.y);

        const btnLeft = parseInt(obj.oCoords.tl.corner.bl.x + 120);
        // console.log("btnLeft " + btnLeft);
        const btnTop = parseInt(obj.oCoords.tl.corner.bl.y - 35);
        // console.log("btnTop " + btnTop);
        const deleteBtn = `<img src="/modules/personnalisation/views/img/icons/close.png" class="deleteBtn" style="position:absolute;top:${btnTop}px;left:${btnLeft}px;cursor:pointer;width:20px;height:20px;"/>`;
        $('#wrapper_custom').append(deleteBtn);
        // console.log("append body delete btn");
    }

    sortResults(prop, asc) {
        let { images } = Populate.storage.arr_slogan;
        images = images.sort((a, b) => {
            if (asc) {
                return a[prop] > b[prop] ? 1 : a[prop] < b[prop] ? -1 : 0;
            }
            return b[prop] > a[prop] ? 1 : b[prop] < a[prop] ? -1 : 0;
        });
    }
}
